<template>
  <generic-modal
    size="large"
    :title="$t('session review')"
    icon="fax"
    image="/images/icons/edit.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
    :footer_buttons="footer_buttons"
  >
    <div class="description">
      <div
        class="ui red right floated labeled mini icon button"
        @click="delete_session"
      >
        <i class="trash icon"></i>
        {{ $t("delete") }}
      </div>
      <h4 class="ui dividing header">{{ $t("session overview") }}</h4>
      <div class="ui statistics">
        <div class="green statistic">
          <div class="value">
            {{
              total_sale_amount | formatCurrency(enterprise_setup.currency_iso)
            }}
          </div>
          <div class="label">{{ $t("total sale") }}</div>
        </div>
        <div
          class="ui small statistic"
          v-for="(pmt, idx) in payment_methods"
          :key="idx"
          :class="{ hidden: !pmt.amount }"
        >
          <div class="value">
            {{ pmt.amount | formatCurrency(enterprise_setup.currency_iso) }}
          </div>
          <div class="label">{{ pmt.name }}</div>
        </div>
      </div>
      <div v-if="session.comment">
        {{ $t("comment") }}
        <p>{{ session.comment }}</p>
      </div>
      <table
        ref="table"
        class="ui celled selectable striped very compact table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("total") }}</th>
            <th>{{ $t("details") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(itm, idx) in session.pos_sales"
            :key="idx"
            @click="show_sale(itm)"
          >
            <td>
              {{
                itm.create_date
                  | formatDate(enterprise_setup.detailed_date_format)
              }}
            </td>
            <td>
              {{ itm.total | formatCurrency(enterprise_setup.currency_iso) }}
            </td>
            <td>
              <div
                class="ui basic label"
                v-for="(pm, ix) in itm.payment"
                :key="ix"
                :class="{ hidden: !pm.amount }"
              >
                {{ pm.name }}
                <div class="detail">
                  {{
                    pm.amount | formatCurrency(enterprise_setup.currency_iso)
                  }}
                </div>
              </div>
              <div
                class="ui mini red icon right floated button"
                :tooltip="$t('delete')"
                @click.stop="delete_sale(itm, idx)"
              >
                <i class="trash icon"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import { clone } from "lodash";
import filters from "@/filters";
import { local_api, enterprise_setup } from "@/utils";

export default {
  name: "PointOfSaleSessionModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    session_in: Object,
  },
  computed: {
    total_sale_amount() {
      let r = 0;
      if (this.session && this.session.pos_sales) {
        r = this.session.pos_sales.reduce(function(prev, curr) {
          return prev + Number(curr.total);
        }, 0);
      }
      return r;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      session: {},
      payment_methods: [],
      footer_buttons: [
        // {
        //   color: "orange",
        //   icon: "trash",
        //   text: this.$i18n.t("delete"),
        //   click: this.delete_session
        // }
      ],
    };
  },
  methods: {
    finished() {
      // let vm = this;
      return new Promise(function(resolve) {
        // vm.$emit("finished");
        resolve();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    calculate_total() {
      let total = 0;
      total = this.session.pos_sales.reduce(function(prev, curr) {
        return prev + Number(curr.total);
      }, 0);
      return total;
    },
    show_sale(sale) {
      this.$emit("show_sale", sale);
    },
    delete_session() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete session?"),
        function() {
          local_api(vm, "post", "/point_of_sale/session/do-remove", {
            u: vm.session_in.uuid,
          })
            .then(() => {
              vm.$emit("deleted", vm.session_in);
            })
            .catch((err) => {
              vm.$alertify.error(err);
            });
        },
      );
    },
    delete_sale(item, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to delete sale?"), function() {
        local_api(vm, "post", "/point_of_sale/session/do-remove-sale", {
          u: item.uuid,
        })
          .then(() => {
            vm.session.pos_sales.splice(index, 1);
          })
          .catch((err) => {
            vm.$alertify.error(err);
          });
      });
    },
  },
  mounted() {
    let vm = this;
    vm.session = clone(vm.session_in);
    vm.session.pos_sales = vm.session.pos_sales.map((s) => {
      if (typeof s.payment == "string") s.payment = JSON.parse(s.payment);

      // add it to payment methods for session overview
      s.payment.map((pm) => {
        let trgt = vm.payment_methods.find((p) => p.name == pm.name);
        if (trgt) trgt.amount += Number(pm.amount);
        else
          vm.payment_methods.push({
            name: pm.name,
            amount: Number(pm.amount),
          });
      });

      return s;
    });
  },
  watch: {},
  updated: function() {},
};
</script>
